<table id="my-orders-list-table" class="custom-table">
    <thead>
        <tr>
            @for (column of columns; track column; let index = $index) {
                <th [class.centered]="column.centered" [style.min-width]="column.minWidth" [style.width]="column.width">
                    <span>{{ column.name | translate }}</span>
                </th>
            }
        </tr>
    </thead>

    @if (orderList().length) {
        <tbody>
            @for (order of orderList(); track order; let index = $index) {
                <ng-container
                    [ngTemplateOutlet]="tableRow"
                    [ngTemplateOutletContext]="{ order: order, rowIndex: index }">
                </ng-container>
            }
        </tbody>
    }
</table>

@if (!orderList().length) {
    <div id="my-orders-list-empty-states-container">
        <div id="my-orders-empty-state">
            <app-table-empty-state
                [text1]="'order.list.table.noOrdersEmptyState.firstSentence' | translate"
                [text2]="'order.list.table.noOrdersEmptyState.secondSentence' | translate"
                [btnText]="'order.list.table.noOrdersEmptyState.createOrder' | translate"
                [btnLink]="orderSetupRoute()">
            </app-table-empty-state>
        </div>
    </div>
}

<ng-template #tableRow let-order="order" let-rowIndex="rowIndex">
    <tr
        app-my-orders-table-row
        class="table-row"
        [class.odd]="rowIndex % 2 === 0"
        [class.even]="rowIndex % 2 === 1"
        [id]="order.id + '-row'"
        [columns]="columns"
        [order]="order"></tr>
</ng-template>
